// extracted by mini-css-extract-plugin
module.exports = {"NotFound":"NotFound_NotFound__1i95r","Url":"NotFound_Url__2a_qd"};